import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { TicketsService,MessageService } from 'src/app/services';
import { CreateTicketFormFields } from 'src/app/models/tickets/createTicketFormFields';
import { BartTicketSave } from 'src/app/models/tickets/bart.ticket.save'
import {AccessUserInfo } from 'src/app/models';
import { TicketStatus } from 'src/app/enum/ticket/ticket-status.enum';
import { ConfService } from 'src/conf.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'bart-batch-ticket-summary',
  templateUrl: './batch-ticket-summary.component.html',
  styleUrls: ['./batch-ticket-summary.component.scss']
})
export class BatchTicketSummaryComponent implements OnInit 
{
  datePiepe = new DatePipe('en-US')
  public styleName:string="";
  public useExistingCss:boolean=true;

  public formFields:CreateTicketFormFields;
  userId:number;
  bartRoleCode:string;
  userName:string
  bartRoleId:number;
  firstLastName:string=""
  public totalTime:number
  public partTotalAmount:number;
  public singlePrintTotalAmount:number;
  public printTitle:string;
  public yesReleaseEquipRadioButtonShow:boolean=true;
  public noReleaseEquipRadioButtonShow:boolean=true;
  public ShowAdminVoidDailoge:boolean=false;
  public batchColumns: any[];
  public batchPartColumns: any[];
  public batchWorkType:string="";
  public equipmentCount=1;
  public isTicketClosed:boolean=false;
  constructor
  (
    private activatedRoute: ActivatedRoute,
    private _ticketService: TicketsService,
    private router: Router ,
    private _bartTicketSave:BartTicketSave,
    private  _messageService:MessageService
  )
  {
    this.formFields=new CreateTicketFormFields()
  
    let userInfo = AccessUserInfo.getUserInfo();
    if(userInfo!=null)
    {
      this.userId=userInfo.userId
      this.bartRoleCode=userInfo.bartRoleCode
      this.userName=userInfo.userName
      this.bartRoleId=userInfo.bartRoleId
      this.firstLastName=userInfo.firstLastName;
      // this.lastName=userInfo.lastName;
      
    }
    
  }

  ngOnInit() {
    this.applyPrintCSSForProductionBuild();
    this.batchColumns = 
    [
      {field: 'ticketNumber', header: 'Ticket#'},
      {field: 'equipmentSerialNumber', header: 'Serial#'},
      {field: 'manufacturerName', header: 'Manufacturer'},
      {field: 'modelDescription', header: 'Model'}
    ]
    this.batchPartColumns = 
    [
      {field: 'partNumber', header: 'Part#', width: '20%',},
      {field: 'manufacturerName', header: 'Vendor', width: '20%'},
      {field: 'partDescription', header: 'Part Name' , width: '30%'},
      {field: 'unitCost', header: 'Price', width: '5%'},
      {field: 'quantity', header: 'Quantity', width: '5%'},
     
    ]
    this._ticketService.getTicketGlobalData().subscribe((Result: any) => {   
      this.formFields=Result;
        this.addTemplateColumn();

        
        this.printTitle="Ticket "+this.formFields.ticketNumber
        if(this.formFields.ticketStatusId==TicketStatus.Closed)
        {
          this.loadTicketParts(this.formFields.TicketId);
          this.formFields.isReleaseEquipRadioDisabled=true
          this.calculateTotal();
          this.isTicketClosed=true;
        }
        else
        {
          this.calculateTotal();
        }
        this.populateClosedSummary();
     }, 
     (error) => {
       console.log(error);
     }
   );

  
    if (this.bartRoleCode == 'BOMX' || this.bartRoleCode == 'BOM' || this.bartRoleCode == 'ADMIN') 
    {
        if (this.formFields.ticketStatusId ==TicketStatus.Void) 
        {
          this.formFields.isTSVoidButtonShow=true
        }
    }
    this.formFields.btnHideCloseTicketSummary=true;
  }
 public addTemplateColumn()
 {
     
      let  workTypeText:string=this.formFields.selectedWorkTypeName==null?"":this.formFields.selectedWorkTypeName.toLowerCase();
      if (workTypeText == 'electrical safety') 
      {		//ELECTRICAL SAFETY
        this.batchColumns.push
        (
          {field: 'electricalLeakage', header: 'Electrical Leakage'},
          {field: 'groundWireResistance', header: 'Ground Wire Resistance'}
        )
      }
      else if (workTypeText == 'water volume' || workTypeText == 'volume template') 
      {		//WATER VOLUME//volume template

        if(workTypeText == 'volume template')
        {
          this.batchColumns.push
          (
            {field: 'waterVolume', header: 'Volume'},
          )
        }
        else
        {
          this.batchColumns.push
          (
            {field: 'waterVolume', header: 'Water Volume'},
          )
        }
      }
      else if (workTypeText == 'water duration') {		//WATER DURATION
        this.batchColumns.push
        (
          {field: 'waterDurationA', header: 'Water Duration (A)'},
          {field: 'waterDurationB', header: 'Water Duration (B)'},
          {field: 'waterDurationC', header: 'Water Duration (C)'},
          {field: 'waterDurationD', header: 'Water Duration (D)'},
          {field: 'waterDurationE', header: 'Water Duration (E)'}
        )
      }
      else if (workTypeText == 'water frequency')
       {		//WATER FREQUENCY
        this.batchColumns.push
        (
          {field: 'waterFrequency', header: 'Water Frequency'},
        )
        
      }
      else if (workTypeText == 'water volume monthly') 
      {	//WATER VOLUME MONTHLY
        this.batchColumns.push
        (
          {field: 'waterVolumeMonthly', header: 'Water Volume - Monthly'},
         
        )
      }
      else if (workTypeText == 'volume temperature template') 
      {	//WATER VOLUME TEMPERATURE
        this.batchColumns.push
        (
          {field: 'waterTemperatureVolume', header: 'Water Volume'},
          {field: 'waterTemperature', header: 'Water Temperature'},
        )
      }
      else if (workTypeText == 'network survey') 
      {	//NETWORK SURVEY
        this.batchColumns.push
        (
          {field: 'networkSurveyA', header: 'Wall Ports'},
          {field: 'networkSurveyB', header: 'Ethernet Cables'},
          {field: 'networkSurveyC', header: 'Digi Boxes'},
          {field: 'networkSurveyD', header: 'Power Supplies'},
          {field: 'networkSurveyE', header: 'Serial Cables'},
        )
      }			
      else if (workTypeText == 'software versioning') 
      {	//SOFTWARE VERSION UPDATE
        this.batchColumns.push
        (
          {field: 'GeneralSoftware', header: 'Software Version'},
          {field: 'Actuator', header: 'Module 1'},
          {field: 'Functional', header: 'Module 2'},
        )
      }
      else if (workTypeText == 'attestation') 
      {	//COVID ATTESTATION
        this.batchColumns.push
        (
          {field: 'covidAttestationA', header: 'I attest that I do not have a temperature over 100.0 F at this time.', width: '10%'},
          {field: 'covidAttestationB', header: 'I attest that I am not experiencing any coughing or shortness of breath.', width: '10%'},
          {field: 'covidAttestationC', header: 'I attest that I understand that I should not report to work if I am experiencing a temperature greater than or equal to 100.0 F, coughing and / or shortness of breath, and that if I do, I must notify my manager immediately prior to reporting to work.', width: '30%'},
        )
      }			

 }
  public populateClosedSummary() 
  {
    if(this.formFields.ticketSavedByFirstLastName==null || this.formFields.ticketSavedByFirstLastName==undefined || this.formFields.ticketSavedByFirstLastName=="")
      {
        this.formFields.ticketSavedByFirstLastName=this.firstLastName;
        
      }
    if(this.formFields.ticketStatusId ==TicketStatus.Closed && this.formFields.isEquipmentReleasedForTreatmentFlag==1)
    {
          this.yesReleaseEquipRadioButtonShow=true
          this.noReleaseEquipRadioButtonShow=false
    }
    if(this.formFields.ticketStatusId ==TicketStatus.Closed && this.formFields.isEquipmentReleasedForTreatmentFlag==0)
    {
          this.yesReleaseEquipRadioButtonShow=false
          this.noReleaseEquipRadioButtonShow=true
    }
    if(this.formFields.ticketStatusId ==TicketStatus.Closed)
    {
          this.formFields.isReleaseEquipRadioDisabled=true;
          this.formFields.isTSVoidButtonShow=true;
          this.formFields.btnHideCloseTicketSummary=true
    }
   else
   {
    this.formFields.isTSVoidButtonShow=false;
   }

  }
  public radioButtonClicked()
  {
    if(this.formFields.isEquipmentReleasedForTreatmentFlag && this.formFields.ticketStatusId!=TicketStatus.Closed)
    {
      this.formFields.isTSCloseButtonShow=true;
    }
    else
    {
      this.formFields.isTSCloseButtonShow=false;
    }
  }
  public calculateTotal()
  {
    this.applyPrintCSSForProductionBuild();
    //Calculate total Time
     let labourTime=Number(this.formFields.hoursWorkedSel+"."+this.formFields.minutesWorkedSel) 
     let travellTime=Number(this.formFields.hoursTravelSel+"."+this.formFields.minutesTravelSel) 
     this.totalTime=Number(labourTime+travellTime);
    //Calculate Total Part Amount
    setTimeout(() => {
      this.equipmentCount=this.formFields.batchTicketObj.length
      if(this.formFields.batchPart)
      {
        this.partTotalAmount=this.formFields.batchPart.map(t => (t.unitCost* (t.quantity*this.equipmentCount))).reduce((a, b) => a + b, 0)
        this.partTotalAmount= Number(this.partTotalAmount.toFixed(2))
        //Total for Single Ticket
        this.singlePrintTotalAmount=this.formFields.batchPart.map(t => (t.unitCost*t.quantity)).reduce((a, b) => a + b, 0)
        this.singlePrintTotalAmount= Number(this.singlePrintTotalAmount.toFixed(2))
        

      }
    }, 1000);
    
  }
  public goTo(routeName)
  {
    // this.router.navigate(['/'+routeName]);
    window.location.href="/"+routeName
  }
  public hasPermission(btnName)
  {
    let result:Boolean=false
    if(btnName=="Dashboard" &&  "ADMIN,BOM,BOMX,BSS,BSSX".split(",").indexOf(this.bartRoleCode)>-1)
    {
      result= true;
      
    }
    if(btnName=="Void" &&  "ADMIN,BOM,BOMX".split(",").indexOf(this.bartRoleCode)>-1)
    {
      if(this.formFields.TicketId!=null && this.formFields.TicketId>0)
      {
        result= true;
      }
    }
    return result
  }
  public VoidnonBatchTicketSummary() {
    this.ShowAdminVoidDailoge = true;
  }
  async voidClosedTicketBtn() {
    var voidReason = this.formFields.voidClosedReason;
    // for what's left, let's strip newlines out and see if we end up with nothing
    var voidReasonNoCR = voidReason.replace(/^\s+|\s+$/g, '');

    if (voidReasonNoCR.length == 0) 
    {
      this._messageService.showAlertMessage("'You must provide a reason why you\'re voiding this ticket.'");
    } 
    else {
     
      var ticketVoided =await this._bartTicketSave.voidClosedTicket();
      
    };
  }
  public closeTicket()
  {
    var CLOSETICKET=
    {
      "CLOSEBATCHTICKET": 
      {
          TICKETIDLIST: this.formFields.batchTicketObj.map(x=>x.ticketId).join(","),
          ISEQUIPMENTRELEASEDFORTREATMENTFLAG: this.formFields.isEquipmentReleasedForTreatmentFlag==null?0:this.formFields.isEquipmentReleasedForTreatmentFlag,  // Autorization checked 1 else 0,
          SQACODEID: this.formFields.batchDetails.SQACodeId>0?this.formFields.batchDetails.SQACodeId:null,
          SQASUBCODEID: this.formFields.batchDetails.SQASubCodeId>0?this.formFields.batchDetails.SQASubCodeId:null,
          ADDITIONALCOMMENTS: this.formFields.additionalComment,
          USERID: this.userId,
          CLOCKHOURS: this.formFields.clockHours<=0?null:this.formFields.clockHours
      }
    }
    this._ticketService.CloseBatchTicket(JSON.stringify(CLOSETICKET)).subscribe((Result: any) => 
    {
      if (Result == null || Result=="" || Result.length==null ) 
      {
        // enable #backToDash,#printTicket,#newTicket
        this.formFields.isTSCommonButtonShow=true;
        this.formFields.isTSCloseButtonShow=false;
        this.formFields.ticketStatusId=TicketStatus.Closed;
        if(this.formFields.ticketStatusId ==TicketStatus.Closed && this.formFields.isEquipmentReleasedForTreatmentFlag==1)
        {
          this.yesReleaseEquipRadioButtonShow=true
          this.noReleaseEquipRadioButtonShow=false
        }
        if(this.formFields.ticketStatusId ==TicketStatus.Closed && this.formFields.isEquipmentReleasedForTreatmentFlag==0)
        {
          this.yesReleaseEquipRadioButtonShow=false
          this.noReleaseEquipRadioButtonShow=true
        }
        if(this.formFields.ticketStatusId ==TicketStatus.Closed)
        {
          this.formFields.isReleaseEquipRadioDisabled=true;
          this.formFields.btnHideCloseTicketSummary=true
        }
      } 
      else 
      {
        this._messageService.showAlertMessage('An error occurred while attempting to close the ticket.');
      }
    },
      (error) => 
      {
        console.log(error)
      }
    );

  }
  public getCurentTicketdetails(ticketId:number)
  {
    if(this.formFields.batchTicketObj!=null)
    {
      return this.formFields.batchTicketObj.filter(x=>x.ticketId==ticketId)
    }
  }
  public applyPrintCSSForProductionBuild()
  {
    
    this.useExistingCss=true;
    if (ConfService.conf.environment.production) {
      this.useExistingCss = false;
      const elements = document.getElementsByTagName('link');
      for (let index = 0; index < elements.length; index++) {
        console.log(elements[index].href);
        //if (elements[index].href.startsWith(document.baseURI)) {
          this.styleName += elements[index].href + ',';
        //}
      }
      this.styleName = this.styleName.slice(0, -1);
    }
    console.log("Production Build: "+ConfService.conf.environment.production);
    console.log("styleName: "+this.styleName);
    console.log("useExistingCss: "+this.useExistingCss);
    
  }

  //Load ticket parts here if ticket is already Closed
  public loadTicketParts(ticketId) {
    this.formFields.batchPart=[];
    var i = 0;
    var partTotal = 0;
    let getTicketPartsParam =
    {
      "GETTICKETPARTS": {
        TicketID: ticketId
      }
    }
    this._ticketService.getTicketParts(JSON.stringify(getTicketPartsParam)).subscribe(data => {
      if (data != null && data.length > 0) {
        this.formFields.batchPart = data.filter
          (
            (thing, i, arr) => arr.findIndex(t => t.PartID === thing.PartID) === i
          ).
          map(data => ({
            batchPartId: 0,
            batchId: this.formFields.batchDetails.BatchId,
            partId: data.PartID,
            quantity: data.Quantity,
            partDescription: data.partDescription,
            partNumber: data.PartNumber,
            unitCost: data.UnitCost,
            manufacturerName: data.manufacturerName
          }));
          this.calculateTotal();
      }
    },
      (error) => {
        console.log(error);
      }
    )
  }
}
